import React, { useEffect, useState } from 'react';
import {
    Card,
    Badge,
    Tabs,
    Table,
    Button,
    Modal,
    Form,
    Input,
    Select,
    Space,
    Avatar,
    Statistic,
    Row,
    Col,
    Tag,
    Tooltip,
    InputNumber,
    Divider
} from 'antd';
import {
    UserOutlined,
    DollarOutlined,
    FileTextOutlined,
    CreditCardOutlined,
    EditOutlined,
    EyeOutlined,
    DeleteOutlined,
    FilePdfOutlined,
    PlusOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    MailOutlined,
    PhoneOutlined,
    GlobalOutlined,
    BankOutlined,
    ExclamationCircleFilled
} from '@ant-design/icons';
import SideBar from '../../../components/SideBar';
import NavBar from '../../../components/NavBar';
import Footer from '../../../components/Footer';
import { useBreadcrumbTitle } from '../../../contexts/BreadcrumbContext';
import axiosInstance from '../../../variables/api/axiosInstance';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { API_URL, LOGGED_USER, TOKEN } from '../../../variables/constants';
import { frenchDate, frenchDateSimple } from '../../../variables/functions';
import { displayNumbers } from '../../../variables/numbersFunctions';
import { columnsCommissions, columnsContrats, columnsUtilisateurs } from './details/data';
import { AgreementsTab } from './details/AgreementsTab';
import CourtierProfil from './details/CourtierProfil';
import ModalGestionTauxDeCommission from './details/ModalGestionTauxDeCommission';
import { toast } from 'react-toastify';
import EditContratTauxCommission from './details/EditContratTauxCommission';

const { TabPane } = Tabs;
const { Option } = Select;
const { confirm } = Modal;

const DetailsCourtier = () => {
    const { setPageTitle } = useBreadcrumbTitle();
    const [courtier, setCourtier] = useState("");
    const [activeTab, setActiveTab] = useState('1');
    const [agreement, setAgreement] = useState();
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const [tcModalOpen, setTCModalOpen] = useState(false);
    const [contrats, setContrats] = useState([]);
    const [utilisateurs, setUtilisateurs] = useState([]);
    const [myAgreement, setMyAgreement] = useState("");
    const [myAgreementId, setMyAgreementId] = useState(0);
    const [validatedContrats, setValidatedContrats] = useState([]);
    const [commissions, setCommissions] = useState([]);
    const [sumCommission, setSumCommission] = useState(0);
    const [loadingContrats, setLoadingContrats] = useState(true);
    const [tauxCommissions, setTauxCommissions] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedContrat, setSelectedContrat] = useState();
    const [selectedContrats, setSelectedContrats] = useState([]);
    const [editTauxCommissionOpenModal, setEditTauxCommissionOpenModal] = useState(false);
    const [editedTauxCommission, setEditedTauxCommission] = useState(0);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const param = useParams();

    useEffect(() => {
        if (location?.state?.activeTab) {
            setActiveTab(location.state.activeTab);
        }
    }, [location?.state?.activeTab]);

    useEffect(() => {
        if (courtier?.nom) setPageTitle(courtier.nom);
        return () => setPageTitle(null);
    }, [courtier]);

    const saveTauxCommissions = () => {
        console.log('Sauvegarde des taux:', tauxCommissions);
        setLoading(true);
        // tauxCommissions?.forEach((tc) => {
        tauxCommissions.map((tc) => {
            tc.agreementId = myAgreementId
        });
        axiosInstance
            .put(`/api/agreement/update/agreements`, tauxCommissions)
            .then((res) => {
                toast(`Taux de commission défini avec succès!`);
                setTCModalOpen(false);
                setLoading(false);
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                toast(`Taux de commission non modifié!`);
                setTCModalOpen(false);
                setLoading(false);
            });
        // });
        setLoading(false);
        // Ici vous pouvez appeler votre API
    };


    const loadAgreementDocument = (element, court) => {
        const agId = court?.validAgrements?.findIndex((a) => a.agreementId === element.agreementId);
        court?.validAgrements?.length ? agId !== -1 ? setValidated(true) : setValidated(false) : setValidated(false);
        // Agrément sans pièce jointe : ne pas appeler l'API avec « undefined » (→ 500 serveur).
        const filename = element?.document?.split("/")[1];
        if (!filename) {
            setAgreement(null);
            setLoading(false);
            return;
        }
        setLoading(true);
        fetch(
            `${API_URL}/api/agreement/document/${filename}`,
            {
                headers: {
                    Authorization: `Bearer ${TOKEN}`,
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods":
                        "GET, PUT, POST, DELETE, OPTIONS",
                    "Access-Control-Allow-Headers":
                        "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                },
            }
        )
            .then(async (response) => {
                // convert byte to file
                const imageBytes = await response.arrayBuffer();
                let ext = element?.document?.split(".")[1];
                if (ext === "pdf") {
                    let blob = new Blob([imageBytes], { type: "application/pdf" });
                    let imageUrl = URL.createObjectURL(blob);
                    setAgreement(imageUrl);
                    setLoading(false);
                } else {
                    let t = `image/${ext}`;
                    let blob = new Blob([imageBytes], { type: ext });
                    let imageUrl = URL.createObjectURL(blob);
                    setAgreement(imageUrl);
                    setLoading(false);
                }

            })
            .catch((error) => {
                console.log(error);
            });
    }

    useEffect(() => {
        axiosInstance
            .get(`/api/agence/codeId/${param.courtierId}`)
            .then((res) => {
                console.log(res.data);
                if (LOGGED_USER?.profil?.organisme?.typeOrganisme !== "POOL") {
                    const v = res.data?.agrements?.find(ag => ag.compagnie.code === LOGGED_USER?.profil?.organisme?.code);
                    if (v) {
                        setMyAgreementId(v.agreementId);
                        setMyAgreement(v);
                        sessionStorage.setItem("myAgreement", JSON.stringify(v));
                        loadAgreementDocument(v, res.data);

                        axiosInstance
                            .get(`/api/categorie`)
                            .then((res) => {
                                let tcs = [];
                                res.data.filter(e => !e.codeCategorie.startsWith("V")).forEach((cat) => {
                                    tcs.push({
                                        taux: v.tauxCommission?.find(tc => tc.categorie?.codeCategorie === cat.codeCategorie)?.taux || 0,
                                        categorie: cat.nom,
                                        codeCategorie: cat.codeCategorie
                                    });
                                })
                                setTauxCommissions(tcs);
                            })
                            .catch((err) => {
                                console.log(err);
                            });

                    }

                } else {
                    const agreementToDisplay = location?.state?.agreementId
                        ? res.data?.agrements?.find((ag) => ag.agreementId === location.state.agreementId)
                        : null;
                    loadAgreementDocument(agreementToDisplay || res.data.agrements[0], res.data);
                }
                setCourtier(res.data);
                axiosInstance
                    .get(`/api/contrat/courtier/codeAgence/${res.data.codeAgence}`)
                    .then((resp) => {
                        console.log(resp.data);
                        let ctrs = [];
                        let vCtrs = [];
                        let coms = [];
                        let comKeys = [];
                        let valueCommission = 0;
                        resp.data.map((contrat, key) => {
                            if (contrat.reglements && contrat.reglements.length) {
                                // Supprimer les doublons par codeId
                                const uniqueReglements = Object.values(
                                    contrat.reglements.reduce((acc, reg) => {
                                        if (!acc[reg.codeId]) {
                                            acc[reg.codeId] = reg;
                                        }
                                        return acc;
                                    }, {})
                                );

                                uniqueReglements.forEach((reg) => {
                                    reg.montant < 0 && !reg.commissionPaye && comKeys.push(reg.codeId);
                                    coms.push({
                                        key: reg.codeId,
                                        codeId: reg.codeId,
                                        id: reg.codeId,
                                        numeroPolice: contrat.numeroPoliceP,
                                        souscripteur: contrat?.souscripteur?.prenom
                                            ? `${contrat?.souscripteur?.prenom} ${contrat?.souscripteur?.nom}`
                                            : `${contrat?.souscripteur?.nom}`,
                                        organisme: contrat.organisme.raisonSociale,
                                        dateEffet: contrat?.dateEffet ? frenchDate(contrat?.dateEffet) : "",
                                        dateEcheance: contrat?.dateEcheance ? frenchDateSimple(contrat?.dateEcheance) : "",
                                        regle: reg.dateReglement ? "REGLE" : "NON REGLE",
                                        data: reg,
                                        contrat: contrat
                                    });
                                    valueCommission += reg.commission ? reg.commission : 0;
                                });
                            }


                            contrat.statutContrat === "VALIDE" && vCtrs.push(contrat);

                            ctrs.push({
                                key: contrat.codeId,
                                codeId: contrat.codeId,
                                id: key,
                                numeroPolice: contrat.numeroPoliceP,
                                souscripteur: contrat?.souscripteur?.prenom
                                    ? `${contrat?.souscripteur?.prenom} ${contrat?.souscripteur?.nom}`
                                    : `${contrat?.souscripteur?.nom}`,
                                organisme: contrat.organisme.raisonSociale,
                                dateEffet: contrat?.dateEffet
                                    ? `${frenchDate(contrat?.dateEffet)}`
                                    : "",
                                dateEcheance: contrat?.dateEcheance
                                    ? `${frenchDateSimple(contrat?.dateEcheance)} `
                                    : "",
                                regle: contrat.reglements
                                    ? contrat.reglements.length
                                        ? "REGLE"
                                        : "NON REGLE"
                                    : "NON REGLE",
                                data: contrat,
                            });
                            // console.log("CTRS: ", ctrs);
                        });
                        // console.log("Commmmss:", coms);
                        let _coms = coms.filter(e => e.data.montant < 0 && !e.data.commissionPaye);
                        // console.log("____Commmmss:", _coms);
                        setSelectedContrats(_coms);
                        setSelectedRows(_coms);
                        setSelectedRowKeys(comKeys);
                        setContrats(ctrs);
                        setValidatedContrats(vCtrs);
                        setCommissions(coms);
                        setSumCommission(valueCommission);
                        setLoadingContrats(false);
                    })
                    .catch((err) => {
                        console.log(err);
                    });

                axiosInstance
                    .get(`/api/utilisateur/courtiers/${res.data.codeAgence}`)
                    .then((resp) => {
                        // Tri alphabétique global (nom puis prénom)
                        const sorted = (resp.data || []).slice().sort((a, b) =>
                            `${a?.personne?.nom || ""} ${a?.personne?.prenom || ""}`.localeCompare(
                                `${b?.personne?.nom || ""} ${b?.personne?.prenom || ""}`,
                                "fr",
                                { sensitivity: "base" }
                            )
                        );
                        setUtilisateurs(sorted);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            })
            .catch((err) => {
                console.log(err);
            });
    }, [param?.courtierId, location?.state?.agreementId]);

    const validatedAgency = (agency) => {
        let v = 0;
        v = agency?.validAgrements?.findIndex(ag => ag.compagnie.code === LOGGED_USER?.profil?.organisme?.code);
        return v !== -1;
    }

    const editTauxCommissions = (record) => {
        setSelectedContrat(record.contrat);
        setEditedTauxCommission(record.data.tauxCommission);
        setEditTauxCommissionOpenModal(true);
    }

    // Confirm revoquer courtier
    const confirmRevoquer = () => {
        confirm({
            title: "Êtes-vous sûr de vouloir revoquer ce courtier?",
            icon: <ExclamationCircleFilled />,
            content: "Cette action est definitive",
            okText: "Oui",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                handleRevokeAgreement();
            },
            okButtonProps: { loading: confirmLoading },
            loading: confirmLoading
        });
    }

    const handleRevokeAgreement = () => {
        setConfirmLoading(true);
        axiosInstance
            .get(`/api/agreement/agence/revoke/${myAgreement?.agreementId}`)
            .then((res) => {
                setConfirmLoading(false);
                toast("Agréement révoké avec succès!");
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                setConfirmLoading(false);
            });
    }

    return (
        <div className="layout-wrapper layout-content-navbar  ">
            <div className="layout-container">
                <SideBar />

                {/* <!-- Layout container --> */}
                <div className="layout-page">
                    <NavBar />

                    {/* <!-- Content wrapper --> */}
                    <div className="content-wrapper">
                        {/* <!-- Content --> */}
                        <div className="container-xxl flex-grow-1 container-p-y">
                            <div style={{
                                padding: '10px 18px',
                                background: '#f5f7fa',
                                minHeight: '90vh'
                            }}>
                                {/* En-tête */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #242166 0%, #1890ff 100%)',
                                    padding: '12px 24px',
                                    borderRadius: '12px',
                                    marginBottom: '24px',
                                    boxShadow: '0 4px 12px rgba(36, 33, 102, 0.15)'
                                }}>
                                    <Row justify="space-between" align="middle">
                                        <Col>
                                            <div style={{ color: 'white' }}>
                                                <h2 style={{
                                                    color: 'white',
                                                    margin: 0,
                                                    fontSize: '28px',
                                                    fontWeight: 700
                                                }}>
                                                    {courtier?.nom}
                                                </h2>
                                                <p style={{
                                                    color: 'rgba(255,255,255,0.85)',
                                                    margin: '8px 0 0 0',
                                                    fontSize: '16px'
                                                }}>
                                                    Code courtier: <strong>#{courtier?.codeAgence}</strong> |
                                                    Date de création: <strong>{frenchDate(courtier?.createdAt)}</strong>
                                                </p>
                                                {/* Référence de l'arrêté d'autorisation d'exercice (renseignée
                                                    notamment par l'import de la liste officielle). Masquée si absente. */}
                                                {courtier?.referenceArrete && (
                                                    <p style={{
                                                        color: 'rgba(255,255,255,0.85)',
                                                        margin: '4px 0 0 0',
                                                        fontSize: '14px'
                                                    }}>
                                                        Autorisation d'exercice : <strong>{courtier.referenceArrete}</strong>
                                                    </p>
                                                )}
                                            </div>
                                        </Col>
                                        <Col>
                                            <Button
                                                danger
                                                size="large"
                                                icon={<DeleteOutlined />}
                                                disabled={!validated}
                                                style={{
                                                    borderRadius: '8px',
                                                    height: '44px',
                                                    fontWeight: 600
                                                }}
                                                onClick={() => confirmRevoquer()}
                                            >
                                                Révoquer le courtier
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>

                                <Row gutter={[24, 24]}>
                                    {/* Sidebar gauche */}
                                    <Col xs={24} lg={8}>
                                        <CourtierProfil courtier={courtier} setTCModalOpen={setTCModalOpen} tauxCommissions={tauxCommissions} myAgreement={myAgreement} />
                                    </Col>

                                    {/* Contenu principal */}
                                    <Col xs={24} lg={16}>
                                        <Card
                                            style={{
                                                borderRadius: '12px',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                border: 'none',
                                                minHeight: '600px'
                                            }}
                                        >
                                            <Tabs
                                                activeKey={activeTab}
                                                onChange={setActiveTab}
                                                size="large"
                                                style={{
                                                    '& .ant-tabs-tab': {
                                                        fontWeight: 600
                                                    }
                                                }}
                                            >
                                                <TabPane
                                                    tab={
                                                        <span>
                                                            <FileTextOutlined />
                                                            Contrats
                                                        </span>
                                                    }
                                                    key="1"
                                                >
                                                    <Table
                                                        columns={columnsContrats(navigate)}
                                                        dataSource={contrats}
                                                        pagination={{
                                                            pageSize: 10,
                                                            showSizeChanger: true,
                                                            showTotal: (total) => `Total: ${total} contrats`
                                                        }}
                                                        style={{
                                                            '& .ant-table-thead > tr > th': {
                                                                background: '#fafafa',
                                                                fontWeight: 600,
                                                                color: '#262626'
                                                            }
                                                        }}
                                                    />
                                                </TabPane>

                                                <TabPane
                                                    tab={
                                                        <span>
                                                            <DollarOutlined />
                                                            Commissions
                                                        </span>
                                                    }
                                                    key="2"
                                                >
                                                    <Table
                                                        columns={columnsCommissions(editTauxCommissions)}
                                                        dataSource={commissions}
                                                        pagination={{
                                                            pageSize: 10,
                                                            showSizeChanger: true,
                                                            showTotal: (total) => `Total: ${total} commissions`
                                                        }}
                                                        style={{
                                                            '& .ant-table-thead > tr > th': {
                                                                background: '#fafafa',
                                                                fontWeight: 600,
                                                                color: '#262626'
                                                            }
                                                        }}
                                                    />
                                                </TabPane>

                                                <TabPane
                                                    tab={
                                                        <span>
                                                            <CheckCircleOutlined />
                                                            Agréements
                                                        </span>
                                                    }
                                                    key="3"
                                                >
                                                    <div style={{ textAlign: 'center', padding: '15px 5px' }}>
                                                        <AgreementsTab agrements={courtier?.agrements} courtier={courtier} tauxCommissions={tauxCommissions} validated={validated} validatedAgency={validatedAgency} myAgreement={myAgreement} agreementDocument={agreement} setTCModalOpen={setTCModalOpen} focusAgreementId={location?.state?.agreementId} />
                                                    </div>
                                                </TabPane>

                                                <TabPane
                                                    tab={<span> <UserOutlined /> Utilisateurs </span>}
                                                    key="4"
                                                >
                                                    <Button
                                                        type="primary"
                                                        icon={<PlusOutlined />}
                                                        size="large"
                                                        disabled={!courtier?.codeAgence}
                                                        onClick={() => navigate(`/ajouter-utilisateur/${courtier?.codeAgence}`)}
                                                        style={{
                                                            marginBottom: '16px',
                                                            background: 'linear-gradient(135deg, #242166 0%, #1890ff 100%)',
                                                            border: 'none',
                                                            borderRadius: '8px',
                                                            fontWeight: 600
                                                        }}
                                                    >
                                                        Ajouter un utilisateur
                                                    </Button>
                                                    <div style={{ textAlign: 'center', padding: '15px 5px' }}>
                                                        {utilisateurs.length > 0 ? < Table
                                                            columns={columnsUtilisateurs}
                                                            dataSource={utilisateurs}
                                                            pagination={{
                                                                pageSize: 10,
                                                                showSizeChanger: true,
                                                                showTotal: (total) => `Total: ${total} commissions`
                                                            }}
                                                            style={{
                                                                '& .ant-table-thead > tr > th': {
                                                                    background: '#fafafa',
                                                                    fontWeight: 600,
                                                                    color: '#262626'
                                                                }
                                                            }}
                                                        /> : <div style={{ textAlign: 'center', padding: '45px 15px' }}>
                                                            <UserOutlined style={{
                                                                fontSize: '72px',
                                                                color: '#d9d9d9',
                                                                marginBottom: '24px'
                                                            }} />
                                                            <h3 style={{ color: '#262626', marginBottom: '12px' }}>
                                                                Aucun utilisateur
                                                            </h3>
                                                            <p style={{ color: '#8c8c8c' }}>
                                                                Commencez par ajouter des utilisateurs pour ce courtier
                                                            </p>
                                                        </div>}
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </Card>
                                    </Col>
                                </Row>

                                {/* Modal Taux de Commission */}
                                <ModalGestionTauxDeCommission tcModalOpen={tcModalOpen} setTCModalOpen={setTCModalOpen} saveTauxCommissions={saveTauxCommissions} tauxCommissions={tauxCommissions} setTauxCommissions={setTauxCommissions} courtier={courtier} myAgreement={myAgreement} />

                                {/* Modal pour editer le taux de commission d'un contrat */}
                                <EditContratTauxCommission editTauxCommissionOpenModal={editTauxCommissionOpenModal} setEditTauxCommissionOpenModal={setEditTauxCommissionOpenModal} editedTauxCommission={editedTauxCommission} setEditedTauxCommission={setEditedTauxCommission} loading={loading} setLoading={setLoading} selectedContrat={selectedContrat} />
                            </div>
                        </div>
                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div className="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>

            {/* <!-- Overlay --> */}
            <div className="layout-overlay layout-menu-toggle"></div>

            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div className="drag-target"></div>
        </div >
    );
};

export default DetailsCourtier;
